(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cy-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.cyReady) return;
      root.dataset.cyReady = '1';
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* Colonnes : ouvertes sur ordinateur, en accordéon sur mobile */
      const cols = [...root.querySelectorAll('[data-cy-foot-col]')];
      const mq = window.matchMedia('(min-width: 750px)');
      const sync = () => cols.forEach((d) => { if (mq.matches) d.open = true; else d.open = false; });
      sync();
      mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync);
      cols.forEach((d) => d.querySelector('summary').addEventListener('click', (e) => { if (mq.matches) e.preventDefault(); }));

      /* Retour en haut, en douceur */
      root.querySelector('[data-cy-top]')?.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
        document.getElementById('MainContent')?.focus?.({ preventScroll: true });
      });

      /* Apparition échelonnée des blocs */
      const items = [root.querySelector('.cy-foot__promises'), root.querySelector('.cy-foot__brand'), ...root.querySelectorAll('.cy-foot__col')].filter(Boolean);
      if (!reduce && 'IntersectionObserver' in window) {
        items.forEach((el, i) => { el.setAttribute('data-cy-foot-in', ''); el.style.transitionDelay = (i * 70) + 'ms'; });
        const io = new IntersectionObserver((entries) => {
          entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
        }, { rootMargin: '0px 0px -5% 0px' });
        items.forEach((el) => io.observe(el));
      }
    };
    const run = () => document.querySelectorAll('[data-cy-foot]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cy-journal-boussole"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.cyReady) return;
      root.dataset.cyReady = '1';
      const moods = [...root.querySelectorAll('.cy-jbou__mood')];
      const panels = [...root.querySelectorAll('.cy-jbou__panel')];
      const select = (id) => {
        moods.forEach((m) => m.setAttribute('aria-pressed', String(m.dataset.mood === id)));
        panels.forEach((p) => {
          const on = p.dataset.panel === id;
          p.hidden = !on;
          p.classList.toggle('is-active', on);
          if (on) { p.classList.remove('is-entering'); void p.offsetWidth; p.classList.add('is-entering'); }
        });
      };
      moods.forEach((m) => m.addEventListener('click', () => select(m.dataset.mood)));
      root.querySelector('[data-cy-dice]')?.addEventListener('click', () => {
        const current = moods.findIndex((m) => m.getAttribute('aria-pressed') === 'true');
        let next = current;
        if (moods.length > 1) { while (next === current) next = Math.floor(Math.random() * moods.length); }
        select(moods[next].dataset.mood);
      });
      root.addEventListener('shopify:block:select', (e) => { const b = e.target.closest('[data-mood]'); if (b) select(b.dataset.mood); });
    };
    const run = () => document.querySelectorAll('[data-cy-boussole]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cy-journal-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.documentElement.classList.add('cy-js');
    const init = (root) => {
      if (!root || root.dataset.cyReady) return;
      root.dataset.cyReady = '1';

      /* Apparitions douces, échelonnées */
      const items = root.querySelectorAll('.cy-reveal');
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
        }, { rootMargin: '0px 0px -8% 0px' });
        items.forEach((el, i) => { el.style.transitionDelay = (i * 70) + 'ms'; io.observe(el); });
      } else { items.forEach((el) => el.classList.add('is-in')); }

      /* Survol d'une rubrique : l'image du collage change */
      const layers = root.querySelectorAll('.cy-jhero__layer');
      const show = (key) => {
        let target = root.querySelector('.cy-jhero__layer[data-layer="' + key + '"]');
        if (!target) target = root.querySelector('.cy-jhero__layer[data-layer="default"]');
        layers.forEach((l) => l.classList.toggle('is-active', l === target));
      };
      root.querySelectorAll('[data-cy-rub-link]').forEach((a) => {
        a.addEventListener('pointerenter', () => show(a.dataset.cyRubLink));
        a.addEventListener('focus', () => show(a.dataset.cyRubLink));
        /* Clic : filtre instantané du journal (sans recharger la page) */
        a.addEventListener('click', (ev) => {
          const journal = document.querySelector('[data-cy-journal]');
          if (!journal || journal.dataset.serverFiltered === 'true') return;
          ev.preventDefault();
          journal.dispatchEvent(new CustomEvent('cy-journal:filter', { detail: { rub: a.dataset.cyRubLink, scroll: true } }));
        });
      });
      root.querySelector('.cy-jhero__list')?.addEventListener('pointerleave', () => show('default'));
    };
    const run = () => document.querySelectorAll('[data-cy-jhero]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cy-journal-manifeste"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const run = () => {
      const items = document.querySelectorAll('[data-cy-reveal-root] .cy-reveal:not(.is-in)');
      if (!('IntersectionObserver' in window)) { items.forEach((el) => el.classList.add('is-in')); return; }
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      items.forEach((el, i) => { el.style.transitionDelay = ((i % 6) * 80) + 'ms'; io.observe(el); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);

    /* Ancres de la page (#boussole, #qui-sommes-nous, #journal) : défilement
       doux jusqu'à la cible. Les ancres #rubrique-… restent au journal. */
    if (!window.__cyAnchorBound) {
      window.__cyAnchorBound = true;
      const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      document.addEventListener('click', (ev) => {
        const a = ev.target.closest('a[href*="#"]');
        if (!a || ev.defaultPrevented || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button !== 0) return;
        const url = new URL(a.href, location.href);
        if (url.pathname !== location.pathname || !url.hash || url.hash.startsWith('#rubrique-')) return;
        const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
        if (!target) return;
        ev.preventDefault();
        target.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth', block: 'start' });
        history.replaceState(null, '', location.pathname + location.search + url.hash);
        const focusEl = target.querySelector('.cy-jbou__mood[aria-pressed="true"]');
        if (focusEl) setTimeout(() => focusEl.focus({ preventScroll: true }), reduce() ? 0 : 800);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cy-journal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const norm = (s) => (s || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const init = (root) => {
      if (!root || root.dataset.cyReady) return;
      root.dataset.cyReady = '1';
      if (root.dataset.serverFiltered === 'true') return; /* page /tagged/… : rendu serveur suffisant */

      const grid = root.querySelector('[data-cy-grid]');
      const cards = [...grid.querySelectorAll('.cy-jcard')];
      const pause = grid.querySelector('[data-cy-pause]');
      const chips = [...root.querySelectorAll('.cy-chip')];
      const strip = root.querySelector('.cy-journal__chips');
      const status = root.querySelector('[data-cy-status]');
      const defaultStatus = status ? status.innerHTML : '';
      const search = root.querySelector('[data-cy-search]');
      const searchWrap = root.querySelector('[data-cy-search-wrap]');
      const moreWrap = root.querySelector('[data-cy-more-wrap]');
      const moreBtn = root.querySelector('[data-cy-more]');
      const progress = root.querySelector('[data-cy-progress]');
      const progressBar = root.querySelector('[data-cy-progress-bar]');
      const empty = root.querySelector('[data-cy-empty]');
      const bar = root.querySelector('[data-cy-bar]');
      const pageSize = parseInt(root.dataset.pageSize, 10) || 12;
      cards.forEach((c) => { c._q = norm(c.dataset.q); });

      let state = { rub: 'all', q: '', limit: pageSize + 1 };
      if (searchWrap) searchWrap.hidden = false;
      root.classList.add('is-enhanced');

      /* Temps de lecture cumulé, affiché dans l'ouverture */
      const total = cards.reduce((s, c) => s + (parseInt(c.dataset.min, 10) || 0), 0);
      document.querySelectorAll('[data-cy-total-min]').forEach((el) => {
        const v = el.querySelector('[data-cy-total-min-value]');
        if (v && total > 0) { v.textContent = total.toLocaleString('fr-FR'); el.hidden = false; }
      });

      /* Apparition échelonnée */
      const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -6% 0px' }) : null;
      const watch = (el, i) => {
        if (!io || reduce()) { el.classList.add('is-in'); return; }
        el.style.transitionDelay = ((i % 3) * 90) + 'ms';
        io.observe(el);
      };

      const render = () => {
        const matches = cards.filter((c) => (state.rub === 'all' || c.dataset.rub === state.rub) && (!state.q || c._q.includes(state.q)));
        let shown = 0;
        cards.forEach((c) => { c.hidden = true; c.classList.remove('cy-jcard--feature', 'cy-jcard--wide'); });
        matches.forEach((c, i) => {
          if (i < state.limit) {
            c.hidden = false; shown++;
            if (i === 0 && !state.q) c.classList.add('cy-jcard--feature');
            else if (i > 0 && (i - 1) % 8 === 4) c.classList.add('cy-jcard--wide');
            if (!c.classList.contains('is-in')) watch(c, i);
          }
        });
        /* Carte « pause » après la 6e lecture visible */
        if (pause) {
          const visible = matches.slice(0, state.limit);
          if (visible.length >= 7 && state.rub === 'all' && !state.q) {
            visible[5].after(pause); pause.hidden = false; watch(pause, 0);
          } else { pause.hidden = true; }
        }
        empty.hidden = matches.length > 0;
        const rest = matches.length - shown;
        moreWrap.hidden = rest <= 0;
        if (rest > 0) {
          progress.textContent = shown + ' lectures sur ' + matches.length;
          progressBar.style.width = Math.round((shown / matches.length) * 100) + '%';
          moreBtn.textContent = 'Afficher ' + Math.min(rest, pageSize) + ' lectures de plus';
        }
        chips.forEach((ch) => { if (ch.dataset.rub === state.rub) ch.setAttribute('aria-current', 'true'); else ch.removeAttribute('aria-current'); });
        if (status) {
          const chip = chips.find((ch) => ch.dataset.rub === state.rub);
          if (state.q) status.textContent = matches.length + (matches.length > 1 ? ' lectures trouvées' : ' lecture trouvée');
          else if (state.rub !== 'all' && chip) status.innerHTML = '<strong>' + chip.dataset.label + '</strong> · ' + chip.dataset.desc;
          else status.innerHTML = defaultStatus;
        }
      };

      const apply = (patch, opts = {}) => {
        /* L'état change tout de suite ; seule l'image à l'écran passe par la transition */
        state = { ...state, ...patch };
        if (document.startViewTransition && !reduce() && opts.animate !== false) document.startViewTransition(render); else render();
        if ('rub' in patch) {
          const url = new URL(location.href);
          url.hash = state.rub === 'all' ? '' : 'rubrique-' + state.rub;
          history.replaceState(null, '', url.pathname + url.search + url.hash);
          const chip = chips.find((ch) => ch.dataset.rub === state.rub);
          if (chip && strip && strip.scrollWidth > strip.clientWidth) strip.scrollTo({ left: chip.offsetLeft - strip.clientWidth / 2 + chip.offsetWidth / 2, behavior: reduce() ? 'auto' : 'smooth' });
        }
        if (opts.scroll) {
          const top = root.getBoundingClientRect().top + window.scrollY - 8;
          window.scrollTo({ top, behavior: reduce() ? 'auto' : 'smooth' });
        }
      };

      chips.forEach((ch) => ch.addEventListener('click', (ev) => {
        ev.preventDefault();
        apply({ rub: ch.dataset.rub, limit: pageSize + 1 }, { scroll: bar.classList.contains('is-stuck') });
      }));
      let t;
      search?.addEventListener('input', () => {
        clearTimeout(t);
        t = setTimeout(() => apply({ q: norm(search.value.trim()), limit: pageSize + 1 }, { animate: false }), 160);
      });
      moreBtn.addEventListener('click', () => {
        const before = cards.filter((c) => !c.hidden).length;
        apply({ limit: state.limit + pageSize }, { animate: false });
        const next = cards.filter((c) => !c.hidden)[before];
        next?.querySelector('a')?.focus({ preventScroll: true });
      });
      root.querySelector('[data-cy-reset]')?.addEventListener('click', () => {
        if (search) search.value = '';
        apply({ rub: 'all', q: '', limit: pageSize + 1 });
      });
      root.addEventListener('cy-journal:filter', (e) => apply({ rub: e.detail.rub, q: '', limit: pageSize + 1 }, { scroll: !!e.detail.scroll }));

      /* Barre collante : se place sous l'en-tête s'il reste fixe */
      const header = document.querySelector('#header-group header, header-component, .header');
      let lastTop = -1;
      const setTop = () => {
        let top = 0;
        if (header) {
          const r = header.getBoundingClientRect();
          const pos = getComputedStyle(header).position;
          if ((pos === 'sticky' || pos === 'fixed') && r.bottom > 0 && r.top <= 1) top = Math.round(r.bottom);
        }
        if (top !== lastTop) { lastTop = top; root.style.setProperty('--cy-journal-top', top + 'px'); }
      };
      setTop();
      window.addEventListener('resize', setTop, { passive: true });
      /* v1.2 : une seule mesure par image, et seulement quand la barre est collée */
      let ticking = false;
      window.addEventListener('scroll', () => {
        if (ticking || !bar.classList.contains('is-stuck')) return;
        ticking = true;
        requestAnimationFrame(() => { ticking = false; setTop(); });
      }, { passive: true });
      if ('IntersectionObserver' in window) {
        const sentinel = document.createElement('div');
        sentinel.style.cssText = 'height:1px;margin-top:-1px';
        bar.before(sentinel);
        new IntersectionObserver(([e]) => { bar.classList.toggle('is-stuck', !e.isIntersecting && e.boundingClientRect.top < 0); setTop(); }).observe(sentinel);
      }

      /* Adresse partageable : /blogs/articles#rubrique-soin */
      const fromHash = () => {
        const m = location.hash.match(/^#rubrique-([a-z]+)/);
        return m && chips.some((ch) => ch.dataset.rub === m[1]) ? m[1] : 'all';
      };
      state.rub = fromHash();
      render();
      if (state.rub !== 'all') requestAnimationFrame(() => root.scrollIntoView({ block: 'start' }));
      window.addEventListener('hashchange', () => apply({ rub: fromHash(), limit: pageSize + 1 }, { scroll: true }));
    };

    const run = () => document.querySelectorAll('[data-cy-journal]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
